export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function isUUID(str: string): boolean {
  return (
    str.match(
      /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi
    ) !== null
  )
}

export function snackToCamel(str: string): string {
  return str.replace(/_([a-z])/g, g => g[1].toUpperCase())
}

export function camelToSnake(str: string): string {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
}

export function snakeToCamelObject(obj: any): any {
  const newObj: any = {}
  for (const key in obj) {
    newObj[snackToCamel(key)] = obj[key]
  }
  return newObj
}
